import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from 'react-tooltip';
import { useTranslation } from 'react-i18next';

// App components.
import Badge from 'app/client/components/Badge';

// HOC.
import boost from 'app/client/utilities/hoc/boost';

import i18n from './i18n';

// Styled.
import * as S from './styled';

const RoleBadge = ({ id, name, isExonet = false }) => {
  const { t } = useTranslation();
  const tooltipId = `role-badge-${id}`;

  return (
    <>
      <S.BadgeLink
        to={`/customer/roles/${id}`}
        data-tooltip-id={isExonet ? tooltipId : undefined}
        data-tooltip-content={isExonet ? t('roleBadge:managedByExonet') : undefined}
      >
        <Badge color={isExonet ? 'neutral' : 'brand'} icon={isExonet ? 'lock' : undefined}>
          {name}
        </Badge>
      </S.BadgeLink>
      {isExonet && <Tooltip id={tooltipId} positionStrategy="fixed" style={{ zIndex: 300 }} />}
    </>
  );
};

RoleBadge.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  isExonet: PropTypes.bool,
};

export default boost({ i18n })(RoleBadge);
